<template>
  <div class="checkbox-group">
    <ul>
      <li v-for="(event, index) in eventsOptions" :key="index">
        <el-checkbox
          v-model="eventCheckboxes[event.name]"
          :label="event.name"
          :disabled="isCheckboxGroupDisabled(event.name)"
          :accesskey="event.accessKey"
          @change="alertDestructive(event.name)"
        >
          {{ event.label }}
        </el-checkbox>
      </li>
    </ul>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import mapValues from 'lodash.mapvalues';
import { NAVIGATION_ACCESS_KEYS } from '@/constants';
import get from 'lodash.get';

const { noMealsInWeekByEventShortcuts: navigationAccessKeys } = NAVIGATION_ACCESS_KEYS;

export default {
  name: 'CheckboxWeekDisable',
  props: {
    updateCheckboxes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      eventCheckboxes: { all: false, breakfast: true, lunch: true },
    };
  },
  computed: {
    ...mapState('user', { userOffice: (state) => state.user.office }),
    ...mapState('orders', {
      ordersWeek: (state) => state.byUserWeek,
    }),
    ...mapState('weeklyMenu', {
      isDueDate: (state) => state.isDueDate,
      disabledDays: (state) => state.disabledDays,
      week: (state) => state.week,
    }),
    eventsOptions() {
      const { meals, breakfast, lunch } = navigationAccessKeys;
      const noBreakfast = get(Vue.prototype.$flags, 'noBreakfast', false);
      if (noBreakfast) {
        return [
          {
            label: this.$t('calendar.noMealCheckboxes.all'),
            name: 'all',
            accessKey: meals,
          },
        ];
      }

      return [
        {
          label: this.$t('calendar.noMealCheckboxes.all'),
          name: 'all',
          accessKey: meals,
        },
        {
          label: this.$t('calendar.noMealCheckboxes.breakfast'),
          name: 'breakfast',
          accessKey: breakfast,
        },
        {
          label: this.$t('calendar.noMealCheckboxes.lunch'),
          name: 'lunch',
          accessKey: lunch,
        },
      ];
    },
    hasNoOrders() {
      return this.ordersWeek.length === 0;
    },
  },
  watch: {
    ordersWeek: 'handleOrdersPlaced',
    updateCheckboxes: 'updateAndResetCheckboxes',
  },
  methods: {
    ...mapActions('orders', {
      setUserNextWeekOrders: 'setUserNextWeekOrders',
    }),
    ...mapActions('weeklyMenu', {
      setDisabledDays: 'setDisabledDays',
      setDisabledEvents: 'setDisabledEvents',
      setDisableWeekFlag: 'setDisableWeekFlag',
    }),
    isCheckboxGroupDisabled(eventName) {
      return this.isDueDate || (eventName === 'all' ? false : this.eventCheckboxes.all);
    },
    updateAndResetCheckboxes() {
      if (this.updateCheckboxes) {
        this.handleOrdersPlaced();
        this.$emit('reset-update-checkboxes');
      }
    },
    handleOrdersPlaced() {
      let eventCheckboxesClone = Object.assign({}, this.eventCheckboxes);
      eventCheckboxesClone = mapValues(eventCheckboxesClone, () => true);
      eventCheckboxesClone.all = this.hasNoOrders;
      Object.keys(eventCheckboxesClone).forEach((eventName, eventIndex) => {
        Object.values(this.ordersWeek).forEach((order) => {
          if (order.menuInfo.event === eventIndex) {
            eventCheckboxesClone[eventName] = false;
          }
        });
      });
      this.eventCheckboxes = eventCheckboxesClone;
    },
    alertDestructive(eventName) {
      this.$emit('alert-destructive', eventName, this.eventCheckboxes[eventName]);
    },
  },
};
</script>
<style scoped lang="scss">
/deep/.checkbox-group li {
  display: inline-block;
  margin-right: 20px;

  span {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckboxWeekDisable.vue